export const pickImageUrl = (
  imageUrls?: Record<string, string> | null,
  imageFilename?: string | null | undefined
): string | null => {
  if (imageUrls) {
    const preferredOrder = [
      'hero_card',
      'hero_card_960x540',
      'card',
      'card_400x400',
      'full',
      'full_460x996',
      'thumb',
      'thumb_200x200',
      'feed',
      'feed_1080x1920'
    ];
    for (const key of preferredOrder) {
      const candidate = imageUrls[key];
      if (candidate) {
        return candidate;
      }
    }

    const fallback = Object.values(imageUrls).find(Boolean);
    if (fallback) {
      return fallback;
    }
  }

  if (!imageFilename) {
    return null;
  }

  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  if (!baseUrl) {
    return null;
  }

  const normalizedBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  return `${normalizedBase}/images/${imageFilename}`;
};
